import React from 'react'
import { Container,Col,Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { colors } from '../../assets/jss/landingPageSections/Theme/WebTheme'
const EffortlessBooking = () => {
  return (
    <>
      <div
        style={{
          backgroundColor: colors.LandingPage_Front,
          padding: "60px 0px",
        }}
      >
        <Container>
          <Row>
            <Col xs={12} sm={12} md={6}
            style={{display:"flex",justifyContent:"",alignItems:"",flexDirection:"column"}}
            >
              {/* <div style={{ color: "#000", fontSize: "18px", fontWeight:"600" }}>
                Passenger app
              </div> */}
              {/* <div
                style={{
                  fontSize: "35px",
                  padding: "12px 0px",
                  textTransform: "capitalize",
                  lineHeight: "50px",
                  fontWeight: "700",
                  color:"#000"
                }}
              >
                <strong style={{ color: "#000" }}>Effortless Booking</strong>{" "}
                In The Palm Of Your Hand
              </div> */}
              <div
                style={{
                  color: "#444",
                  fontSize: "1rem",
                  fontFamily: "Poppins",
                }}
              >
               Welcome to Execlane We are a well-established chauffeur company based in Manchester and North England. Our mission is to provide comfortable, reliable and safe journeys to all our valued passengers while upholding excellent customer service. We strive for every trip to be enjoyable, smooth and stress-free.
                <br />
                <br />
                All vehicles are professionally deep cleaned and sanitised to ensure our customers have maximum safety during every journey.
              </div>
              <Link to="/customer/ourServices">   <div
                style={{
                  color: "#fff",
                  background: "#000",
                  fontWeight: "660",
                  padding: "9px 21px",
                  width: "164px",
                  textAlign: "center",
                  marginTop: "25px",
                  height: "50px",
                  lineHeight: "33px",
                  fontSize: "18px",
                  borderRadius:"10px"
                }}
              >
                Our Services
              </div></Link>
            </Col>
            <Col xs={12} sm={12} md={6}>
              {" "}
              <div >
                <img
                  src="https://wubu.co.uk/images/about.jpg"
                  style={{ maxWidth: "100%" }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default EffortlessBooking